import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useHasMenu } from '../../../auth/access';
import { SectionTitle } from '../../shared/components';
import EmployeesTab from '../components/setup/EmployeesTab';

/**
 * Payroll → Pay Profiles: each employee's monthly salary (with its history), PF / ESI / PT,
 * TDS and bank details. Editing is the menu's EDIT action.
 */
export default function PayProfilesPage() {
  const canEdit = useHasMenu('payroll.profiles', 'EDIT');
  return (
    <Stack gap={3}>
      <SectionTitle title='PAY PROFILES' />
      {!canEdit && <Alert severity='info'>Read only — your role can view pay profiles but not change them.</Alert>}
      <EmployeesTab canEdit={canEdit} />
    </Stack>
  );
}
